import React from "react";
import { Modal, Btn } from "./UI";
import { Package } from "lucide-react";

// Reusable "Toplu Envantere Kaydet" wizard — Formuller ve Sales Order detay ortak.
// Ayrı dosyada tutulur (Iter 93: SalesOrders <-> Formulas circular import fix).
export function BulkInvWizard({ bulkInv, setBulkInv, bulkBusy, onSave }) {
  if (!bulkInv) return null;
  const pending = bulkInv.rows.filter(r => r.status !== "success").length;
  return (
    <Modal open={!!bulkInv} onClose={() => !bulkBusy && setBulkInv(null)} title={`Toplu Envantere Kaydet — ${bulkInv.rows?.length || 0} manuel malzeme`} size="lg">
      <div className="space-y-3">
        <div className="text-[11px] bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-800 px-3 py-2 rounded">
          Tüm manuel malzemeler sırayla envanter kaydına dönüştürülecek ve formüle otomatik bağlanacak.
        </div>
        <div className="max-h-[400px] overflow-y-auto">
          <table className="w-full text-xs" data-testid="bulk-inv-table">
            <thead className="bg-slate-100 text-slate-600 text-[10px] uppercase">
              <tr>
                <th className="text-left px-2 py-2">Tip</th>
                <th className="text-left px-2 py-2">Malzeme Adı</th>
                <th className="text-left px-2 py-2">Kategori</th>
                <th className="text-left px-2 py-2">Birim</th>
                <th className="text-right px-2 py-2">Birim Maliyet (EUR)</th>
                <th className="text-center px-2 py-2">Durum</th>
              </tr>
            </thead>
            <tbody>
              {bulkInv.rows.map((r, i) => (
                <tr key={`${r.kind}-${r.index}-${i}`} className="border-t border-slate-100">
                  <td className="px-2 py-1"><span className={`inline-block text-[10px] px-1.5 py-0.5 rounded ${r.kind === "raw" ? "bg-slate-100 text-slate-700" : "bg-amber-100 text-amber-800"}`}>{r.kind === "raw" ? "Hammadde" : "Ambalaj"}</span></td>
                  <td className="px-2 py-1"><input value={r.name} onChange={e => setBulkInv(prev => ({ rows: prev.rows.map((x, j) => j === i ? { ...x, name: e.target.value } : x) }))} disabled={bulkBusy || r.status === "success"} className="w-full px-2 py-1 text-xs border rounded" data-testid={`bulk-inv-name-${i}`}/></td>
                  <td className="px-2 py-1">
                    <select value={r.category} onChange={e => setBulkInv(prev => ({ rows: prev.rows.map((x, j) => j === i ? { ...x, category: e.target.value } : x) }))} disabled={bulkBusy || r.status === "success"} className="w-full px-1 py-1 text-xs border rounded" data-testid={`bulk-inv-cat-${i}`}>
                      <option value="raw_material">Hammadde</option>
                      <option value="active">Aktif</option>
                      <option value="fragrance">Parfüm</option>
                      <option value="aux">Yardımcı</option>
                      <option value="primary_packaging">Birincil Amb.</option>
                      <option value="secondary_packaging">İkincil Amb.</option>
                      <option value="other_packaging">Diğer Amb.</option>
                    </select>
                  </td>
                  <td className="px-2 py-1">
                    <select value={r.unit} onChange={e => setBulkInv(prev => ({ rows: prev.rows.map((x, j) => j === i ? { ...x, unit: e.target.value } : x) }))} disabled={bulkBusy || r.status === "success"} className="w-full px-1 py-1 text-xs border rounded">
                      <option value="kg">kg</option><option value="g">g</option><option value="l">l</option><option value="ml">ml</option><option value="adet">adet</option>
                    </select>
                  </td>
                  <td className="px-2 py-1"><input type="number" step="0.0001" value={r.unit_cost} onChange={e => setBulkInv(prev => ({ rows: prev.rows.map((x, j) => j === i ? { ...x, unit_cost: parseFloat(e.target.value) || 0 } : x) }))} disabled={bulkBusy || r.status === "success"} className="w-full px-2 py-1 text-xs border rounded text-right font-mono" data-testid={`bulk-inv-cost-${i}`}/></td>
                  <td className="px-2 py-1 text-center">
                    {r.status === "pending" && <span className="text-slate-400 text-[10px]">— Bekliyor</span>}
                    {r.status === "success" && <span className="text-emerald-700 text-[10px] font-semibold" data-testid={`bulk-inv-ok-${i}`}>✓ Kaydedildi</span>}
                    {r.status === "warn_no_match" && <span className="text-amber-700 text-[10px] font-semibold" title={r.error || "Formül line'ı ile eşleşemedi"}>⚠ Kayıt OK, eşleşme yok</span>}
                    {r.status === "error" && <span className="text-red-700 text-[10px] font-semibold" title={r.error || "Hata"}>✗ Hata</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center pt-2 border-t border-slate-100">
          <div className="text-[11px] text-slate-500">{bulkBusy ? "İşleniyor..." : `${pending} satır bekliyor`}</div>
          <div className="flex gap-2">
            <Btn variant="secondary" onClick={() => setBulkInv(null)} disabled={bulkBusy}>Kapat</Btn>
            <Btn onClick={onSave} disabled={bulkBusy || pending === 0} data-testid="bulk-inv-save">
              <Package size={12}/> {bulkBusy ? "Kaydediliyor..." : `${pending} Malzemeyi Kaydet & Bağla`}
            </Btn>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default BulkInvWizard;
